// import resolveConfig from 'tailwindcss/resolveConfig';
// import tailwindConfig from '../tailwind.config';
import colors from 'tailwindcss/colors';
// const fullConfig = resolveConfig(tailwindConfig);

export const twColors = colors;
